import React from "react";
import Form from "./Form";
import { useFormik } from "formik";
import { create } from "ducks/distanceRules";
import { add } from "ducks/toasts";

import { connect } from "react-redux";
import { useRemoveQueryNavigation } from "helpers/hooks/url";
const CreateDistanceRule = ({ add, create }) => {
  const onClose = useRemoveQueryNavigation("createDistanceRule");
  const { values, handleSubmit, setFieldValue } = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      description: "",
      color: [211, 96, 134, 100],
      target: [],
      source: [],
      distance: 350
    },
    onSubmit: ({ withFormat, format, ...rest }) => {
      create({ format: withFormat ? JSON.stringify(format) : null, ...rest });
      add(
        "Update erfolgreich",
        "Benutzer wurde erfolgreich aktualisiert",
        "success",
        "user"
      );
    }
  });

  return values ? (
    <Form
      subtitle="Abstandsregel erstellen"
      values={values}
      handleChange={setFieldValue}
      handleSubmit={handleSubmit}
      handleClose={onClose}
    ></Form>
  ) : (
    false
  );
};

export default connect(null, { create, add })(CreateDistanceRule);
